import { TJsonQuery } from '../../../packages/JsonQuery';
import { setJsonQuery } from 'shared/slices/jsonQuery';
import { applyFilters } from 'shared/thunks/filters';
import { updateSearchMeta } from 'shared/thunks/searchMeta';
import { updateTags } from 'shared/thunks/tags';
import { TAsyncThunkAction } from 'shared/types/redux';

/**
 * Заменяет jsonQuery на переданный и прогоняет тот же цикл обновления фильтров,
 * что и изменение фильтра руками (useFilterChangeCallback): подтягивает searchMeta,
 * пересобирает теги и эмитит `filters:updated`.
 *
 * searchMeta обновляем до applyFilters: без нее событие не будет отправлено. Дебаунс
 * здесь не нужен — вызов приходит от потребителя разово, а не по вводу в фильтр.
 */
export const applyJsonQuery =
  (jsonQuery: TJsonQuery): TAsyncThunkAction =>
  async dispatch => {
    dispatch(setJsonQuery(jsonQuery));

    await dispatch(updateSearchMeta({ immediate: true }));

    dispatch(updateTags());
    dispatch(applyFilters());
  };
